import React from 'react';
// import NavbarDropdown from './NavbarDropdown';
// import {
//   dashboardRoutes,
//   appRoutes,
//   pagesRoutes,
//   modulesRoutes,
//   documentationRoutes
// } from 'routes/siteMaps';
// import { Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import paths, { rootPaths } from 'routes/paths';
// import { flatRoutes } from 'helpers/utils';
// import NavbarDropdownApp from './NavbarDropdownApp';
// import NavbarDropdownPages from './NavbarDropdownPages';
// import NavbarDropdownModules from './NavbarDropdownModules';
// import { useAppContext } from 'providers/AppProvider';

const NavbarTopDropDownMenus = () => {
  // const {
  //   config: { navbarCollapsed, showBurgerMenu },
  //   setConfig
  // } = useAppContext();

  // const handleDropdownItemClick = () => {
  //   if (navbarCollapsed) {
  //     setConfig('navbarCollapsed', !navbarCollapsed);
  //   }
  //   if (showBurgerMenu) {
  //     setConfig('showBurgerMenu', !showBurgerMenu);
  //   }
  // };
  return (
    <>
      <NavLink
        to={rootPaths.root}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Dashboard</h6>
      </NavLink>

      <NavLink
        to={paths.nursd_order}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Orders</h6>
      </NavLink>

      <NavLink
        to={paths.nursd_people}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">People</h6>
      </NavLink>

      <NavLink
        to={paths.credential}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Compliance</h6>
      </NavLink>

      <NavLink
        to={paths.nursd_schedule}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Schedule</h6>
      </NavLink>

      <NavLink
        to={paths.nursd_time_sheet()}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Timesheet</h6>
      </NavLink>

      <NavLink
        to={paths.analytics}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 'lighter',
          marginTop: '1rem',
          borderBottomWidth: isActive ? 3 : 0,
          borderBottomStyle: 'solid',
          borderBottomColor: '#00B0F0',
          textDecorationLine: 'none'
        })}
      >
        <h6 className="nav-link">Analytics</h6>
      </NavLink>
      {/* <NavbarDropdown title="dashboard">
        {dashboardRoutes.children[0].children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title="app">
        <NavbarDropdownApp items={appRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="pages">
        <NavbarDropdownPages items={pagesRoutes.children} />
      </NavbarDropdown>
      <NavbarDropdown title="modules">
        <NavbarDropdownModules items={modulesRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="documentation">
        {flatRoutes(documentationRoutes.children).map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown> */}
    </>
  );
};

export default NavbarTopDropDownMenus;
